import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import { styled } from '@zenbusiness/zui/styles';

export const StyledVeloBanner = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.grey.main,
  borderRadius: theme.shape.rounded.lg,
  border: `1px solid ${theme.palette.border.main}`,
  color: theme.palette.text.primary,
  display: 'flex',
  flex: '1 0 0',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(2),

  '& .MuiStack-root': {
    gap: '4px !important',
  },

  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
  },
}));

export const VeloButton = styled(Button)(({ theme }) => ({
  borderRadius: '10px',
  width: '100%',
  minWidth: '100%',
  padding: '6px 10px',
  backgroundColor: theme.palette.background.grey.light,
  color: theme.palette.text.primary,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.fontSize.sm,
  '&:hover': {
    backgroundColor: theme.palette.background.grey.light,
    color: theme.palette.text.primary,
  },
}));

// Wrapper to handle gradient border with border-radius
export const ButtonWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  flex: 1,
  borderRadius: theme.shape.rounded.lg,
  background: 'linear-gradient(249.5deg, #3971E7 27.22%, #33F28B 100%)',
  padding: '2px',
  width: '100%',
}));
